import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import SettingsItem from './settingsItem';
import { userSettingsStore } from '../../store/userSettingsStore';
import { popupStore } from '../../store/popupStore';
import { PopupTypes } from '../../core/constants/popupTypes';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { isMobile } from '../../core/helpers/isMobile';
import './bet-section-bottom-btns.scss';

const Settings = observer(() => {
  const {
    isTurboOn,
    isMusicOn,
    isSoundOn,
    changeTurboModeState,
    setIsMusicOn,
    setIsSoundOn,
    isShowHotKeys,
    isHotKeyEnable,
    isShowTurboIcon,
    isShowMusicIcon,
    isShowSoundIcon,
  } = userSettingsStore;
  const { open } = popupStore;
  const t = useTranslation();

  const openFairness = useCallback(
    (e) => {
      e.stopPropagation();
      open({ name: PopupTypes.Fairness });
    },
    [open]
  );

  const openGameRules = useCallback(
    (e) => {
      e.stopPropagation();
      open({ name: PopupTypes.GameRules });
    },
    [open]
  );

  const openHotKeys = useCallback(
    (e) => {
      e.stopPropagation();
      open({ name: PopupTypes.HotKeys });
    },
    [open]
  );

  return (
    <div className='cpt-bottom-icons-container'>
      {isShowMusicIcon && (
        <SettingsItem
          iconName={`music-${isMusicOn ? 'on' : 'off'}`}
          handleClick={setIsMusicOn}
          isActive={isMusicOn}
          settingsText={t(TranslationKeys.MusicIcon)}
        />
      )}
      {isShowSoundIcon && (
        <SettingsItem
          iconName={`sound-${isSoundOn ? 'on' : 'off'}`}
          handleClick={setIsSoundOn}
          isActive={isSoundOn}
          settingsText={t(TranslationKeys.SoundIcon)}
        />
      )}
      {isShowTurboIcon && (
        <SettingsItem
          iconName='speed'
          isActive={isTurboOn}
          handleClick={changeTurboModeState}
          settingsText={t(TranslationKeys.TurboIcon)}
        />
      )}
      {!isMobile() && isShowHotKeys && (
        <SettingsItem
          iconName='hot-keys'
          handleClick={openHotKeys}
          isActive={isHotKeyEnable}
          settingsText={t(TranslationKeys.HotKeysIcon)}
        />
      )}
      <SettingsItem
        iconName='info'
        handleClick={openGameRules}
        settingsText={t(TranslationKeys.RulesIcon)}
      />
      <SettingsItem
        iconName='fairness'
        isActive
        handleClick={openFairness}
        settingsText={t(TranslationKeys.FairnessIcon)}
      />
    </div>
  );
});

export default Settings;
